import styled, { createGlobalStyle, css } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  body {
    background-color: ${({ theme }) => theme.elsie.colors.canvas.soft};
  }
`;

export const buttoBaseStyle = css`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  font-family: NunitoSans, Verdana, Arial, sans-serif;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.elsie.borderRadius.md};
`;

export const Main = styled.main`
  font-family: NunitoSans, Verdana, Arial, sans-serif;
  margin: 56px auto 0 auto;
  @media only screen and (min-width: 1536px) {
    max-width: 1340px;
  }

  @media only screen and (min-width: 1340px) {
    margin-top: 64px auto 0 auto;
  }
  width: 100%;
`;
